import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import {ArtifactImage} from 'app/components/my_profile/artifacts/image';
import {stringTypeOfBonus} from 'app/utils/stringTypeOfBonus';
import DigitalPrizeImage from './DigitalPrizeImage';

export default class Prize extends PureComponent {
    render() {
        const {loot: {points_amount, money_amount, frozen_money_amount, bonus_amount, bonus, recipe, steam_skin}} = this.props;

        switch (true) {
        case Number(points_amount) > 0:
            return <DigitalPrizeImage
                amount={points_amount}
                measure={I18n.t('points', {count: points_amount})}
            />;
        case Number(money_amount) > 0:
            return <DigitalPrizeImage
                amount={money_amount}
                prefix="$"
            />;
        case Number(frozen_money_amount) > 0:
            return <DigitalPrizeImage
                amount={frozen_money_amount}
                measure={I18n.t('frozen_balance')}
                variant="frozen"
            />;
        case bonus !== null:
            return <DigitalPrizeImage
                amount={bonus_amount}
                prefix="$"
                measure={stringTypeOfBonus(bonus)}
            />;
        default:
            return <ArtifactImage
                artifact={recipe || steam_skin || this.props.recipe}
                showHeroSlotCount
            />;
        }
    }
}
